import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './ScrollIndicator.css';

const ScrollIndicator = ({ containerSelector }) => {
    const [showRight, setShowRight] = useState(false);
    const [showLeft, setShowLeft] = useState(false);

    useEffect(() => {
        const container = document.querySelector(containerSelector);
        if (!container) return;

        const checkScroll = () => {
            setShowRight(
                container.scrollLeft + container.clientWidth <
                    container.scrollWidth - 10
            );
            setShowLeft(container.scrollLeft > 10);
        };

        container.addEventListener('scroll', checkScroll);
        checkScroll();

        return () => container.removeEventListener('scroll', checkScroll);
    }, [containerSelector]);

    const handleClickRight = () => {
        const container = document.querySelector(containerSelector);
        if (!container) return;

        container.scrollBy({
            left: 400,
            behavior: 'smooth',
        });
    };

    const handleClickLeft = () => {
        const container = document.querySelector(containerSelector);
        if (!container) return;

        container.scrollBy({
            left: -400,
            behavior: 'smooth',
        });
    };

    if (!showRight && !showLeft) return null;

    return (
        <>
            {showLeft && (
                <button
                    className="scroll-indicator scroll-indicator-left"
                    onClick={handleClickLeft}
                    aria-label="Scroll left to see previous tiles"
                    type="button"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15 6L9 12L15 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            )}
            {showRight && (
                <button
                    className="scroll-indicator scroll-indicator-right"
                    onClick={handleClickRight}
                    aria-label="Scroll right to see more tiles"
                    type="button"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9 6L15 12L9 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            )}
        </>
    );
};

ScrollIndicator.propTypes = {
    containerSelector: PropTypes.string.isRequired,
};

export default ScrollIndicator;
